export const RESET = 'RESET_CLASSROOMS'

export const GET_CLASSROOMS = 'GET_CLASSROOMS'
export const SET_CLASSROOMS = 'SET_CLASSROOMS'

export const SET_CLASSROOM = 'SET_CLASSROOM'
export const SET_CLASSROOM_NAME = 'SET_CLASSROOM_NAME'

